export interface InputFilter {
  filter: (value: string) => string;
  warning: string;
}

const LAYOUT_WARNING = "Используйте русскую раскладку клавиатуры";

export const inputFilters: Record<"russianName" | "russianText" | "digits" | "departmentCode", InputFilter> = {
  russianName: {
    filter: (value: string) => value.replace(/[^А-Яа-яЁё\s-]/g, ""),
    warning: LAYOUT_WARNING,
  },
  russianText: {
    filter: (value: string) => value.replace(/[^А-Яа-яЁё0-9\s.,;:!?№#"'’«»()/\\\-–—]/g, ""),
    warning: LAYOUT_WARNING,
  },
  digits: {
    filter: (value: string) => value.replace(/\D/g, ""),
    warning: "Можно вводить только цифры",
  },
  departmentCode: {
    filter: (value: string) => value.replace(/[^\d-]/g, ""),
    warning: "Можно вводить только цифры и дефис",
  },
};
